import { render, staticRenderFns } from "./AddSalesTracker.vue?vue&type=template&id=a324a444&scoped=true"
import script from "./AddSalesTracker.vue?vue&type=script&lang=js"
export * from "./AddSalesTracker.vue?vue&type=script&lang=js"
import style0 from "./AddSalesTracker.vue?vue&type=style&index=0&id=a324a444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324a444",
  null
  
)

export default component.exports